import { render, staticRenderFns } from "./IndividualAccount.vue?vue&type=template&id=e5d8cd62&scoped=true"
import script from "./IndividualAccount.vue?vue&type=script&lang=js"
export * from "./IndividualAccount.vue?vue&type=script&lang=js"
import style0 from "./IndividualAccount.vue?vue&type=style&index=0&id=e5d8cd62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d8cd62",
  null
  
)

export default component.exports